import React, { useContext } from "react";
import { useAuth } from "react-oidc-context";
import { HotelContext } from "../../context/HotelContext";
import Translation from "../../utils/Translation";
import V2Sidebar from "./sidebar/Sidebar";
import MyHotelsV2 from "./MyHotelsV2";
import InterrogationIcon from "../../img/v2/interrogation.svg";
import "../../styles/SecretPage.css";
import "./MyHotelsV2.css";

const MyHotelsLayout = () => {
  const auth = useAuth();
  const { lang, setLang } = useContext(HotelContext);

  const userProfile = {
    name:
      auth.user?.profile?.name ??
      `${auth.user?.profile?.given_name ?? "Luni"} ${auth.user?.profile?.family_name ?? "Manager"}`,
    picture: auth.user?.profile?.picture,
  };

  const sidebarItems = [{ key: "my-hotels", label: null }];

  return (
    <div className="secret-v2 my-hotels-layout">
      <V2Sidebar
        items={sidebarItems.map((item) => ({
          ...item,
          label: <Translation tag="v2_my_hotels_sidebar_all" />,
        }))}
        loading={false}
        activeKey="my-hotels"
        onSelect={() => {}}
        userProfile={userProfile}
      />

      <main className="secret-v2__content my-hotels-layout__content">
        <header className="my-hotels-v2__topbar">
          <h1 className="my-hotels-v2__topbar-title">
            <Translation tag="v2_my_hotels_title" />
          </h1>
          <div className="my-hotels-v2__topbar-actions">
            <button
              type="button"
              className="my-hotels-v2__lang-btn"
              onClick={() => setLang(lang === "fr" ? "en" : "fr")}
            >
              {lang.toUpperCase()}
            </button>
            <a
              href="https://www.luniwave.com/contact"
              target="_blank"
              rel="noopener noreferrer"
              className="my-hotels-v2__contact-btn"
            >
              <img
                src={InterrogationIcon}
                alt=""
                aria-hidden="true"
                className="my-hotels-v2__contact-icon"
              />
              <span>
                <Translation tag="v2_my_hotels_contact" />
              </span>
            </a>
          </div>
        </header>

        <section className="secret-v2__main-content my-hotels-layout__main">
          <MyHotelsV2 />
        </section>
      </main>
    </div>
  );
};

export default MyHotelsLayout;
